import request from '@/router/axios';

//fascAuthDetail
export const fascAuthDetail = (deptId) => {
  return request({
    url: '/api/blade-fascDeptAuth/fascDeptAuth/fasc-auth-detail',
    method: 'get',
    params: {
      deptId,
    }
  })
}

//modifyFascAuth
export const modifyFascAuth = (rentType, isAuth, data) => {
  return request({
    url: '/api/blade-fascDeptAuth/fascDeptAuth/modify-fasc-auth/' + rentType + '/' + isAuth,
    method: 'post',
    data
  })
}

//fascCompanySuggestion
export const fascCompanySuggestion = (rentType, keyword) => {
  return request({
    url: '/api/blade-fascDeptAuth/fascDeptAuth/fascCompanySuggestion',
    method: 'get',
    params: {
      keyword,
      rentType
    }
  })
}
//modifyDeptFreeSign
export const modifyDeptFreeSign = (rentType, deptId) => {
  return request({
    url: '/api/blade-fascDeptAuth/fascDeptAuth/modify-dept-free-sign?rentType=' + rentType + '&deptId=' + deptId,
    method: 'get',
  })
}

// 获取法大大列表
export const getfascDeptList = (params) => {
  return request({
    url: `/api/blade-fascDeptAuth/fascDeptAuth/fasc-bind-page`,
    method: "post",
    data: {
      ...params
    },
  });
};

// 保存法大大授权
export const fascBindSave = (params) => {
  return request({
    url: `/api/blade-fascDeptAuth/fascDeptAuth/fasc-bind-save`,
    method: "post",
    data: {
      ...params
    },
  });
};

// 法大大企业授权接口
export const fascBindAuthCompany = (params) => {
  return request({
    url: `/api/blade-fascDeptAuth/fascDeptAuth/fasc-bind-auth`,
    method: "post",
    data: {
      ...params
    },
  });
};

// 法大大企业授权接口
export const fascBindAuthVisaFree = (params) => {
  return request({
    url: `/api/blade-fascDeptAuth/fascDeptAuth/modify-dept-free-bind`,
    method: "post",
    data: {
      ...params
    },
  });
};